module.exports = __webpack_public_path__ + "img/close-modal-menu.b055558e.svg";